export class DataModel{
    dataX:string[];
    dataY:number[];
    dataZ:string[];

    constructor(){}
}